// Türkiye Resmi Tatil Günleri (2024-2030)
// Not: Dini bayramlar (Ramazan/Kurban) hicri takvime dayalı olduğundan resmi takvim yayımlandıkça güncellenir.
// 2027+ için tahmini değerler — kesinleşince güncellenmeli.
export const getTurkishHolidays = (year) => {
  const holidays = {
    2024: [
      '2024-01-01',
      '2024-04-23',
      '2024-05-01',
      '2024-05-19',
      '2024-06-15', '2024-06-16', '2024-06-17',
      '2024-07-15',
      '2024-08-30',
      '2024-10-29',
    ],
    2025: [
      '2025-01-01',
      '2025-04-10', '2025-04-11', '2025-04-12',
      '2025-04-23',
      '2025-05-01',
      '2025-05-19',
      '2025-06-06', '2025-06-07', '2025-06-08', '2025-06-09',
      '2025-07-15',
      '2025-08-30',
      '2025-10-29',
    ],
    2026: [
      '2026-01-01',
      '2026-03-19', '2026-03-20', '2026-03-21', '2026-03-22',
      '2026-04-23',
      '2026-05-01',
      '2026-05-19',
      '2026-05-26', '2026-05-27', '2026-05-28', '2026-05-29', '2026-05-30',
      '2026-07-15',
      '2026-08-30',
      '2026-10-29',
    ],
    2027: [
      '2027-01-01',
      '2027-03-09', '2027-03-10', '2027-03-11',
      '2027-04-23',
      '2027-05-01',
      '2027-05-16', '2027-05-17', '2027-05-18', '2027-05-19',
      '2027-07-15',
      '2027-08-30',
      '2027-10-29',
    ],
    2028: [
      '2028-01-01',
      '2028-02-26', '2028-02-27', '2028-02-28',
      '2028-04-23',
      '2028-05-01',
      '2028-05-05', '2028-05-06', '2028-05-07', '2028-05-08',
      '2028-05-19',
      '2028-07-15',
      '2028-08-30',
      '2028-10-29',
    ],
    2029: [
      '2029-01-01',
      '2029-02-14', '2029-02-15', '2029-02-16',
      '2029-04-23',
      '2029-04-24', '2029-04-25', '2029-04-26', '2029-04-27',
      '2029-05-01',
      '2029-05-19',
      '2029-07-15',
      '2029-08-30',
      '2029-10-29',
    ],
    2030: [
      '2030-01-01',
      '2030-02-04', '2030-02-05', '2030-02-06',
      '2030-04-14', '2030-04-15', '2030-04-16', '2030-04-17',
      '2030-04-23',
      '2030-05-01',
      '2030-05-19',
      '2030-07-15',
      '2030-08-30',
      '2030-10-29',
    ],
  };
  return holidays[year] || [];
};

export const getTurkishArifeDates = (year) => {
  const arife = {
    2024: ['2024-06-14'],
    2025: ['2025-04-09', '2025-06-05'],
    2026: ['2026-03-19', '2026-05-26'],
    2027: ['2027-03-09', '2027-05-16'],
    2028: ['2028-02-26', '2028-05-05'],
    2029: ['2029-02-14', '2029-04-24'],
    2030: ['2030-02-04', '2030-04-14'],
  };
  return arife[year] || [];
};

export const getTurkishHolidaysForLeaveDeduction = (year) => {
  const all = getTurkishHolidays(year) || [];
  const arifeSet = new Set(getTurkishArifeDates(year) || []);
  return all.filter((d) => !arifeSet.has(d));
};

// --- Temel parse / format ---

// YYYY-MM-DD string'inin geçerli bir tarih olduğunu doğrular.
// "2025-02-30" gibi formal olarak doğru ama takvimde olmayan tarihleri reddeder.
export const isValidDateString = (dateStr) => {
  if (!dateStr || typeof dateStr !== 'string') return false;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr);
  if (!match) return false;
  const y = Number(match[1]);
  const m = Number(match[2]);
  const d = Number(match[3]);
  if (m < 1 || m > 12 || d < 1 || d > 31) return false;
  const date = new Date(y, m - 1, d);
  return (
    date.getFullYear() === y &&
    date.getMonth() === m - 1 &&
    date.getDate() === d
  );
};

// YYYY-MM-DD string'ini yerel Date'e çevir (timezone kayması yok).
export function parseLocalDate(dateStr) {
  const [y, m, d] = dateStr.split('-').map(Number);
  return new Date(y, m - 1, d);
}

// Date'i YYYY-MM-DD string yapar (yerel tarihe göre).
export function formatLocalDate(d) {
  if (!d) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// Europe/Istanbul takvim gününü YYYY-MM-DD döndürür — tarayıcının/CI runner'ın
// yerel timezone'undan BAĞIMSIZ (Intl ile açık timeZone). Günlük görev (park bakım)
// iş günü tarihi bununla hesaplanmalı: `new Date().toISOString()` UTC verir ve
// 00:00–03:00 İstanbul aralığında (henüz UTC ertesi güne geçmemişken) bir gün geri
// kalır — kullanıcı yanlış güne bakar. `en-CA` locale'i YYYY-MM-DD üretir.
const _istanbulYmdFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Istanbul', year: 'numeric', month: '2-digit', day: '2-digit',
});
export const getIstanbulDateKey = (d = new Date()) => _istanbulYmdFormatter.format(d);

// Eski isimler ile uyumluluk: LeaveRequestFormDialog, ActivityManagementTab ve
// LeaveRequestCard kendi içlerinde benzer fonksiyon tanımlıyordu. Tek noktaya taşındı.
export const toDateYmd = (dateObj) => {
  if (!dateObj) return '';
  return formatLocalDate(dateObj);
};

export const parseYmdToLocalDate = (dateStr) => {
  if (!dateStr || !isValidDateString(dateStr)) return undefined;
  return parseLocalDate(dateStr);
};

// --- Türkçe görüntüleme yardımcıları ---

// YYYY-MM-DD'yi DD.MM.YYYY olarak formatlar. options.short=true ise DD.MM.YYYY.
// options.weekday=true ise "Çarşamba, 15 Mayıs 2026" gibi tam format.
export const formatTRDate = (dateStr, options = {}) => {
  if (!dateStr || !isValidDateString(dateStr)) return '';
  const d = parseLocalDate(dateStr);
  if (options.weekday) {
    return d.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
      weekday: 'long',
    });
  }
  if (options.long) {
    return d.toLocaleDateString('tr-TR', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }
  // Varsayılan: kısa DD.MM.YYYY
  return d.toLocaleDateString('tr-TR');
};

// --- İş günü / tatil hesapları ---

const isHolidaySet = (dateStr) => {
  if (!isValidDateString(dateStr)) return false;
  const year = Number(dateStr.slice(0, 4));
  return getTurkishHolidaysForLeaveDeduction(year).includes(dateStr);
};

// dateStr (YYYY-MM-DD) bir Türkiye resmi tatili mi?
export const isHoliday = (dateStr) => isHolidaySet(dateStr);

// İşe başlama kuralı:
// - Normalde bitiş tarihinden bir sonraki gün
// - Cuma ise → Pazartesi
// - Pazartesi (veya ileri herhangi bir gün) resmi tatil ise → bir sonraki iş günü
export const getNextWorkday = (endDate) => {
  if (!endDate || !isValidDateString(endDate)) return '';
  const end = parseLocalDate(endDate);
  let next = new Date(end.getFullYear(), end.getMonth(), end.getDate() + 1);

  // Cuma ise → Pazartesi
  if (end.getDay() === 5) {
    next.setDate(next.getDate() + 2);
  }

  // Resmi tatil veya hafta sonu varsa bir sonraki iş gününe ilerle (en fazla 14 gün)
  let safety = 0;
  while (safety < 14) {
    const isoStr = formatLocalDate(next);
    const dow = next.getDay();
    if (dow === 0) {
      next.setDate(next.getDate() + 1);
    } else if (dow === 6) {
      next.setDate(next.getDate() + 2);
    } else if (isHolidaySet(isoStr)) {
      next.setDate(next.getDate() + 1);
    } else {
      break;
    }
    safety += 1;
  }

  return formatLocalDate(next);
};

// İzin günü hesaplama fonksiyonu
// returnDate (işe başlama tarihi) verilirse, izin aralığı son günü = returnDate - 1 gün kabul edilir.
export const calculateLeaveDays = (startDate, endDate, isCivilServant = false, returnDateParam = null) => {
  if (!startDate || !endDate || !isValidDateString(startDate) || !isValidDateString(endDate)) {
    return { weekdays: 0, weekends: 0, total: 0, workdays: 0, returnDate: '' };
  }

  const start = parseLocalDate(startDate);
  const end = parseLocalDate(endDate);

  if (start > end) {
    return { weekdays: 0, weekends: 0, total: 0, workdays: 0, returnDate: '' };
  }

  // İzin süresi YALNIZ seçilen [start, end] aralığıdır. return_date (işbaşı)
  // izin bitişinden sonraki ilk İŞ GÜNÜdür; araya giren hafta sonu/resmi tatil
  // izne DAHİL DEĞİLDİR. (Eskiden end, return_date-1'e uzatılıp cuma tek-gün
  // izinde cmt+paz da sayılıyor, "1 gün" yerine "3 gün" görünüyordu.)
  // return_date yalnız çıktı olarak korunur, sayıma dahil edilmez.
  let returnDateStr;
  if (returnDateParam && isValidDateString(returnDateParam)) {
    returnDateStr = returnDateParam;
  } else {
    const returnDateObj = new Date(end.getFullYear(), end.getMonth(), end.getDate() + 1);
    returnDateStr = formatLocalDate(returnDateObj);
  }

  let weekdays = 0;
  let weekends = 0;
  let workdays = 0;

  const startYear = start.getFullYear();
  const endYear = end.getFullYear();
  const allHolidays = new Set();
  for (let y = startYear; y <= endYear; y += 1) {
    getTurkishHolidaysForLeaveDeduction(y).forEach((d) => allHolidays.add(d));
  }

  const current = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  const endTime = end.getTime();
  while (current.getTime() <= endTime) {
    const dateStr = formatLocalDate(current);
    const dayOfWeek = current.getDay();

    const isWeekend = dayOfWeek === 0 || dayOfWeek === 6;
    const isHolidayDay = allHolidays.has(dateStr);

    if (isWeekend) {
      weekends++;
    } else {
      weekdays++;
      if (!isHolidayDay) {
        workdays++;
      }
    }

    current.setDate(current.getDate() + 1);
  }

  const total = weekdays + weekends;
  const finalWorkdays = isCivilServant ? total : workdays;

  return {
    weekdays,
    weekends,
    total,
    workdays: finalWorkdays,
    returnDate: returnDateStr,
  };
};

// --- Backend timestamp gösterimi ---

// Türkiye saati formatla (backend'den gelen ISO 8601 + TR offset)
export const formatTurkeyTime = (dateString) => {
  if (!dateString) return 'Tarih yok';

  // Backend'den gelen ISO 8601 formatı: "2025-12-15T17:45:00.123456+03:00"
  try {
    const [datePart, timePart] = dateString.split('T');
    if (!datePart || !timePart) return 'Geçersiz tarih';
    const [year, month, day] = datePart.split('-');
    const [time] = timePart.split('.');
    const [hours, minutes] = time.split(':');

    return `${day}.${month}.${year} ${hours}:${minutes}`;
  } catch (e) {
    console.error('Tarih formatlama hatası:', e);
    return 'Geçersiz tarih';
  }
};

// --- Şu anki tarih yardımcıları ---

// Bugünün YYYY-MM-DD stringi (yerel saat)
export const todayYmd = () => formatLocalDate(new Date());
